import React, { useState } from 'react';
import API_BASE from '../utils/apiBase';

const JobApplicationForm = ({ jobs }) => {
  const [form, setForm] = useState({
    name: '',
    birthdate: '',
    email: '',
    workex: '',
    position: jobs[0]?.title || '',
    message: '',
    file: null
  });
  const [status, setStatus] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleFile = e => {
    setForm(prev => ({ ...prev, file: e.target.files[0] }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('Sending...');
    const data = new FormData();
    Object.entries(form).forEach(([k, v]) => data.append(k, v));
    const res = await fetch(`${API_BASE}/api/apply.php`, { method: 'POST', body: data });
    const result = await res.json();
    setStatus(result.success ? 'Application sent!' : 'Error: ' + result.error);
  };

  return (
    <form
      className="space-y-4 w-full"
      onSubmit={handleSubmit}
      encType="multipart/form-data"
    >
      <div>
        <label className="block text-sm font-medium text-white mb-1">Name</label>
        <input
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-white/20 bg-black/30 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white/40 placeholder-gray-400 backdrop-blur-md"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">Birth Date</label>
        <input
          name="birthdate"
          type="date"
          value={form.birthdate}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-white/20 bg-black/30 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white/40 placeholder-gray-400 backdrop-blur-md"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">Email</label>
        <input
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-white/20 bg-black/30 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white/40 placeholder-gray-400 backdrop-blur-md"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">Work Experience</label>
        <input
          name="workex"
          placeholder="Work Experience"
          value={form.workex}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-white/20 bg-black/30 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white/40 placeholder-gray-400 backdrop-blur-md"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">Position Sought</label>
        <select
          name="position"
          value={form.position}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-white/20 bg-black/30 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white/40 placeholder-gray-400 backdrop-blur-md"
        >
          {jobs.map(job => (
            <option key={job.id} value={job.title}>{job.title}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">Upload CV</label>
        <input
          name="file"
          type="file"
          onChange={handleFile}
          required
          className="w-full px-4 py-2 border border-white/20 bg-black/30 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white/40 placeholder-gray-400 backdrop-blur-md"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-white mb-1">Your Message</label>
        <textarea
          name="message"
          placeholder="Your Message"
          value={form.message}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-white/20 bg-black/30 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white/40 placeholder-gray-400 backdrop-blur-md min-h-[80px]"
        />
      </div>
      <button
        type="submit"
        className="w-full py-2 px-4 bg-white/20 hover:bg-white/30 text-white font-semibold rounded-lg shadow transition backdrop-blur-md border border-white/20"
      >
        Send
      </button>
      {status && (
        <div className="form-status text-center text-white font-medium mt-2">{status}</div>
      )}
    </form>
  );
};

export default JobApplicationForm;
